import React from 'react';
import { useWeather } from 'services/weather/hook';
import { Text } from 'components/typography/Text';
import { ForecastItem } from '../ForecastItem';
import { getIconForWeather } from '../../../WeatherSlide';
import styles from './styles.module.scss';

export const WeekForecast = () => {

  const { weather: { daily } } = useWeather();

  return (
    <div className={styles.WeekForecast}>

      <Text
        className={styles.heading}
        intl="theWeek"
        center
        medium
        uppercase
      />

      <div className={styles.itemsWrapper}>
        { daily.map((item, index) => {
          if (index < 7) {
            return (
              <ForecastItem
                labelIntl={item.day}
                icon={getIconForWeather(item.weatherCondition)}
                temp={item.tempMax}
                tempMin={item.tempMin}
                key={index}
              />
            );
          }
          return null;
        })}
      </div>
    </div>
  );
};
